import webClient from '@/network/clients/webClientSetup'
import mocksClient from '@/network/clients/mocksClientSetup'
import { mobileClient, mobileClientPortal } from '@/network/clients/mobileClientSetup'

export const httpClient = window.cordova ? (import.meta.env.VITE_MOCKS === 'true' ? mocksClient.ib : mobileClient) : (import.meta.env.VITE_MOCKS === 'true' ? mocksClient.ib : webClient.ib)
export const httpClientPortal = window.cordova ? mobileClientPortal : (import.meta.env.VITE_MOCKS === 'true' ? mocksClient.portal : webClient.portal)
export const httpClientUrlStringBuilder = import.meta.env.VITE_MOCKS === 'true' ? mocksClient.urlIB : webClient.urlIB
